import {Injectable} from '@angular/core';
import {Crud} from './crud';
import {Observable} from 'rxjs';
import {JsonResponseToolConfigsInterface} from '../../models/sharedinterface';

@Injectable({
  providedIn: 'root'
})
export class CrudUserService extends Crud {
  createEntity(entityjson: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/admin/users';
    return this.http.post(this.serverRoot + url, formData);
  }

  getEntities(): Observable<any> {
    const url = '/v1/admin/users';
    return this.http.get(this.serverRoot + url);
  } // getEntities

  getEntity(id: string = ''): Observable<any> {
    const url = '/v1/admin/users/' + id;
    return this.http.get(this.serverRoot + url);
  } // getEntity

  removeEntity(entityid: string): Observable<any> {
    const url = '/v1/admin/users/' + entityid;
    return this.http.delete(this.serverRoot + url);
  } // removeEntity

  updateEntity(entityid: string, entityjson: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/admin/users/' + entityid;
    return this.http.post(this.serverRoot + url, formData);
  }

  getAdminUserDynamicFormData(): Observable<any> {
    const url = '/v1/admin/formdata';
    return this.http.get(this.serverRoot + url);
  } // getAdminUserDynamicFormData

  getUsertools(userid: string = ''): Observable<any> {
    const url = '/v1/admin/users/' + userid + '/tools';
    return this.http.get(this.serverRoot + url);
  } // getUsertools

  getUserToolConfig(userid: string = '', toolid: string = ''): Observable<JsonResponseToolConfigsInterface> {
    const url = '/v1/admin/users/' + userid + '/tools/' + toolid;
    return this.http.get<JsonResponseToolConfigsInterface>(this.serverRoot + url);
  } // getUserToolConfig

  updateSpecificToolsConfigs(entityjson: any = {}): Observable<any> {
    entityjson.companyid = entityjson.companyid === 0 ? null : entityjson.companyid;
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/admin/users/tools/' + entityjson.id;
    return this.http.post(this.serverRoot + url, formData);
  }

  deleteSpecificToolsConfigs(entityid: number): Observable<any> {
    const formData = new FormData();
    const url = '/v1/admin/users/tools/' + entityid;
    return this.http.delete(this.serverRoot + url);
  }

  createSpecificToolsConfigs(entityjson: any = {}) {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/admin/users/tools';
    return this.http.post(this.serverRoot + url, formData);
  }

  getBlockedUsers(): Observable<any> {
    const url = '/v1/admin/blockedusers';
    return this.http.get(this.serverRoot + url);
  }

  unblockUser(id): Observable<any> {
    const url = '/v1/admin/users/unblock/' + id;
    return this.http.get(this.serverRoot + url);
  }

  unblockUserWithToken(token: any): Observable<any> {
    const url = `/users/unblock/${token}`;
    return this.http.get(this.serverRoot + url);
  }
}
